import * as React from 'react';
import styles from '~/Layouts/Themes/SantaPage/SantaPage.scss';
import { shallowEqual, useSelector } from 'react-redux';
import { State } from '~/Reducers';
import classNames from 'classnames';
import { ICurrentPage } from '~/Actions/ActionAppType';
import { isMobileOrTabletWindow } from '~/utils/utils';
import { isCertificateShowcase, SANTA_FOR_CERTIFICATES_BACKGROUND, SANTA_FOR_GOLD_BACKGROUND } from '~/Layouts/Themes/SantaPage/settings';
import VideoBackground from '~/components/VideoBackground/VideoBackground';
import useMobile from '~/hooks/useMobile';
import { useAvailableSound } from '~/hooks/useAvailableSound';
import isDisabledAnimation from '~/hooks/isDisabledAnimation';

interface IStateSelector {
    currentPage: ICurrentPage;
    categoriesAnimationStatuses: ICategoriesAnimationStatuses;
    isTrusted: boolean;
    categories: ICategories;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        currentPage: state.ReducerApp.currentPage,
        categories: state.ReducerApp.categories,
        categoriesAnimationStatuses: state.ReducerApp.categoriesAnimationStatuses,
        isTrusted: state.ReducerApp.isTrusted,
    };
};

const SantaBackground = () => {
    const state = useSelector<State, IStateSelector>(stateSelector, shallowEqual);
    const { isBundlePage } = state.currentPage || {};
    const _isDisabledAnimation = isDisabledAnimation(state.currentPage?.name);
    const isShowcaseForCertificates = isCertificateShowcase(state.currentPage?.name);
    const [isMobile] = useMobile();
    const isAvailableSoundEffect = useAvailableSound(state.categories[state.currentPage?.name], null);

    const classesBackground = classNames(styles.background, {
        [styles.certificates]: isShowcaseForCertificates,
    });

    const classesWrapper = classNames(styles.backgroundWrapper, {
        [styles.certificates]: isShowcaseForCertificates,
    });

    if (isBundlePage) {
        if (isMobileOrTabletWindow) {
            return (
                <div className={styles.backgroundWrapper}>
                    <div className={classesBackground}></div>
                </div>
            );
        }

        return null;
    }

    let video = SANTA_FOR_GOLD_BACKGROUND;
    if (isShowcaseForCertificates) {
        video = SANTA_FOR_CERTIFICATES_BACKGROUND;
    }

    let muted = !isAvailableSoundEffect;
    if (!state.isTrusted) {
        muted = true;
    }

    return (
        <div className={classNames(classesWrapper)}>
            {isMobileOrTabletWindow || _isDisabledAnimation ? (
                <div className={classesBackground}>
                    <div className={styles.videoBackgroundMask}></div>
                </div>
            ) : (
                <VideoBackground
                    poster={null}
                    video={video}
                    muted={muted}
                    className={styles.videoBackgroundWrapper}
                    volume={0.5}
                    posterClassName={classNames(styles.background, styles.partOne, {
                        [styles.certificates]: isShowcaseForCertificates,
                    })}
                    videoClassName={styles.videoBackground}
                >
                    <div className={styles.videoBackgroundMask}></div>
                </VideoBackground>
            )}
        </div>
    );
};

export default SantaBackground;
